import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './purchase-credits.scss'
import CreditPurchaseBg from 'src/assets/credit-purchase-bg.png'
import CloseIcon from 'assets/icons/close-icon.png'
import FolderIcon from 'src/assets/icons/folder-ico-green.svg'
import SvgIcon from 'src/components/common/SvgIcon'
import {
  getCreditsConfigs,
  buildCheckoutURLForCreditsBundle,
  storeUTMDataByKey
} from 'services/stripe_checkout_configs'
import cn from 'classnames'
import Button from 'src/components/common/Button'
import { connect } from 'react-redux'
import { fetchUserGQ } from 'src/actions/user'
import { setOpenedTabReference } from 'src/actions/stripeCheckout'
import uuid from 'uuid'
import { routerActions } from 'react-router-redux'
import { message } from 'antd'
import { PageContainerContext } from 'services/contexts'

class PurchaseCredits extends Component {
  static contextType = PageContainerContext
  creditBundles = getCreditsConfigs()

  state = {
    selectedBundle: this.creditBundles[0]
  }

  componentDidMount() {
    const { goBack } = this.props

    this.metaTag = document.createElement('meta')
    this.metaTag.setAttribute('name', 'theme-color')
    this.metaTag.setAttribute('content', '#f0fffc')

    document.head.appendChild(this.metaTag)

    this.context.onSetStorageCallback(data => {
      if (data?.hasError) {
        message.error('Payment failed.')
      } else if (data && (data.planUpdated || data.creditsUpdated)) {
        goBack()
      }
    })
  }

  componentWillUnmount() {
    if (this.metaTag) {
      document.head.removeChild(this.metaTag)
    }
  }

  openStripeCheckoutTab() {
    const { reloadUser } = this.props
    const userReloadCallback = resp => {
      const user = resp?.data?.me
      if (user) {
        const utmCode = uuid.v4()
        storeUTMDataByKey(user.current_subscription, utmCode)
        const href = buildCheckoutURLForCreditsBundle(this.state.selectedBundle, user.id, utmCode)
        /* safari will block window.open in async calls, wrap it with setTimeout can get around it */
        /* short-turn solution: */
        /* https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari */
        /* long-turn solution: */
        /* use promise instead of callback to handle network requests in src/sagas/api.js:apiWorker() */
        setTimeout(() => {
          const newTabRef = window.open(href, '_blank')
          this.props.setOpenedTabRef(newTabRef)
        }, 0)
      }
    }

    reloadUser(userReloadCallback)
  }

  handlePurchaseCredits = () => {
    this.openStripeCheckoutTab()
  }

  render() {
    const { goBack } = this.props
    const items = this.creditBundles

    return (
      <div className={styles['purchase-credits-container']}>
        <div className={styles['header-container']}>
          <h1>
            Get more
            <br />
            Smart Invites!
          </h1>
          <img src={CreditPurchaseBg} className={styles['credit-purchase-bg']} alt="" />
          <img width={20} src={CloseIcon} className={styles['close-icon']} onClick={goBack} />
        </div>

        <div className={styles['content-container']}>
          <h3>
            <SvgIcon width={20} height={20} icon={FolderIcon} padding="5px" />
            Select credits quantity{' '}
          </h3>
          <div className={styles['subtitle']}>(Credits bought here will never expire)</div>

          <ul className={styles['bundle-grid']}>
            {items.map((item, i) => {
              return (
                <div
                  key={i}
                  className={cn(styles['bundle-item'], {
                    [styles['selected']]: item.stripeId === this.state.selectedBundle.stripeId
                  })}
                  onClick={() => this.setState({ selectedBundle: item })}
                >
                  <div>
                    <span className={styles['item-sub-total']}>{item.creditsNumber}</span>
                  </div>
                  <div>
                    <span className={styles['item-price-label']}>{item.priceLabel}</span>
                  </div>
                </div>
              )
            })}
          </ul>
        </div>

        <div className={styles['price-summary']}>
          <div className={styles['price-summary-item']}>
            <span>Unit Price x Quantity </span>
            <span>{this.state.selectedBundle?.formula}</span>
          </div>
          <div className={styles['price-summary-item']}>
            <span>
              <b>Total Price</b>
            </span>
            <span>
              <b>{this.state.selectedBundle?.subTotalLabel}</b>
            </span>
          </div>
        </div>

        <div className={styles['purchase-button']}>
          <Button className={styles['button-inner']} onClick={this.handlePurchaseCredits}>
            PURCHASE
          </Button>
        </div>
      </div>
    )
  }
}

PurchaseCredits.propTypes = {
  reloadUser: PropTypes.func,
  setOpenedTabRef: PropTypes.func,
  goBack: PropTypes.func
}

function mapDispatchToProps(dispatch) {
  return {
    setOpenedTabRef: tabRef => {
      dispatch(setOpenedTabReference(tabRef))
    },
    reloadUser: successCallback => {
      dispatch(fetchUserGQ(successCallback))
    },

    goBack: () => dispatch(routerActions.goBack())
  }
}

export default connect(null, mapDispatchToProps)(PurchaseCredits)
